import React from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import {
  Box,
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
} from '@mui/material';

function SiteFilterDropdown({
  selectedSite, onSiteChange, sites,
}) {
  const isMobile = useMediaQuery('(max-width:425px)');

  return (
    <Box
      sx={{
        mb: 2, display: 'flex', alignItems: 'center', gap: 2,
      }}
    >
      <FormControl sx={{ minWidth: 200 }}>
        <Select
          value={selectedSite}
          onChange={(e) => onSiteChange(e.target.value)}
          displayEmpty
          input={<OutlinedInput />}
          sx={{
            maxHeight: '44px',
            minWidth: '240px',
            width: isMobile ? '100%' : '20%',
            mt: isMobile ? 2 : 0,
          }}
          renderValue={(value) => {
            if (!value) {
              return <span style={{ color: '#666' }}>All Sites</span>;
            }
            const foundSite = sites.find((site) => site.id === value);
            return foundSite ? foundSite.name : value;
          }}
        >
          <MenuItem value="">
            All Sites
          </MenuItem>
          {sites.map((site) => (
            <MenuItem key={site.id} value={site.id}>
              {site.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

SiteFilterDropdown.propTypes = {
  selectedSite: PropTypes.string.isRequired,
  onSiteChange: PropTypes.func.isRequired,
  sites: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default SiteFilterDropdown;
